/* eslint-disable import/order */
import React, { FunctionComponent } from 'react';
import { defaultIcon } from './icons.css';
import accountBox from './icons/account-box.svg';
import account from './icons/account.svg';
import addBox from './icons/add-box.svg';
import addToCart from './icons/add-to-cart.svg';
import androidArrowDropdown from './icons/android-arrow-dropdown.svg';
import aperture from './icons/aperture.svg';
import apple from './icons/apple.svg';
import archive from './icons/archive.svg';
import arrowDown from './icons/arrow-down.svg';
import arrowLeft from './icons/arrow-left.svg';
import arrowNorthEast from './icons/arrow-north-east.svg';
import arrowReturnLeft from './icons/arrow-return-left.svg';
import arrowRightA from './icons/arrow-right-a.svg';
import briefcase from './icons/briefcase.svg';
import calendar from './icons/calendar.svg';
import call from './icons/call.svg';
import cancel from './icons/cancel.svg';
import cart from './icons/cart.svg';
import chatBubble from './icons/chat-bubble.svg';
import checkBox from './icons/check-box.svg';
import checkmarkCircled from './icons/checkmark-circled.svg';
import checkmark from './icons/checkmark.svg';
import chevronDown from './icons/chevron-down.svg';
import chevronLeft from './icons/chevron-left.svg';
import chevronRight from './icons/chevron-right.svg';
import chevronUp from './icons/chevron-up.svg';
import closeCircled from './icons/close-circled.svg';
import close from './icons/close.svg';
import collapseAll from './icons/collapse-all.svg';
import colorPalette from './icons/color-palette.svg';
import comfortable from './icons/comfortable.svg';
import comment from './icons/comment.svg';
import compact from './icons/compact.svg';
import compareArrows from './icons/compare-arrows.svg';
import compare from './icons/compare.svg';
import construct from './icons/construct.svg';
import contentCopy from './icons/content-copy.svg';
import copyOutline from './icons/copy-outline.svg';
import copySharp from './icons/copy-sharp.svg';
import cube from './icons/cube.svg';
import deleteForever from './icons/delete-forever.svg';
import edit from './icons/edit.svg';
import ellipsisHorizontal from './icons/ellipsis-horizontal.svg';
import email from './icons/email.svg';
import error from './icons/error.svg';
import expandAll from './icons/expand-all.svg';
import eye from './icons/eye.svg';
import facebook from './icons/facebook.svg';
import fergusonIsotype from './icons/ferguson-isotype.svg';
import filterAlt from './icons/filter-alt.svg';
import filter from './icons/filter.svg';
import folder from './icons/folder.svg';
import grabBarsSmall from './icons/grab-bars-small.svg';
import grabBarsVertical from './icons/grab-bars-vertical.svg';
import grabBars from './icons/grab-bars.svg';
import grid3x3 from './icons/grid-3x3.svg';
import grid from './icons/grid.svg';
import hammer from './icons/hammer.svg';
import heart from './icons/heart.svg';
import helpCircle from './icons/help-circle.svg';
import history from './icons/history.svg';
import homeOwner from './icons/home-owner.svg';
import home from './icons/home.svg';
import house from './icons/house.svg';
import houzz from './icons/houzz.svg';
import info from './icons/info.svg';
import instagram from './icons/instagram.svg';
import iphone from './icons/iphone.svg';
import lightBulb from './icons/light-bulb.svg';
import link from './icons/link.svg';
import listAlt from './icons/list-alt.svg';
import list from './icons/list.svg';
import lock from './icons/lock.svg';
import loop from './icons/loop.svg';
import menu from './icons/menu.svg';
import minus from './icons/minus.svg';
import move from './icons/move.svg';
import notificationBell from './icons/notification-bell.svg';
import other from './icons/other.svg';
import paperOutline from './icons/paper-outline.svg';
import personStalker from './icons/person-stalker.svg';
import person from './icons/person.svg';
import phone from './icons/phone.svg';
import pinterest from './icons/pinterest.svg';
import plusCircled from './icons/plus-circled.svg';
import plus from './icons/plus.svg';
import priceTag from './icons/price-tag.svg';
import print from './icons/print.svg';
import prop65Warning from './icons/prop65-warning.svg';
import quickShip from './icons/quick-ship.svg';
import refresh from './icons/refresh.svg';
import returns from './icons/returns.svg';
import search from './icons/search.svg';
import send from './icons/send.svg';
import shieldCheckmarkSharp from './icons/shield-checkmark-sharp.svg';
import shieldCheckmark from './icons/shield-checkmark.svg';
import shipmentTracking from './icons/shipment-tracking.svg';
import shippingBox from './icons/shipping-box.svg';
import shoppingCart from './icons/shopping-cart.svg';
import sort from './icons/sort.svg';
import storeFront from './icons/store-front.svg';
import thumbsDown from './icons/thumbs-down.svg';
import thumbsUp from './icons/thumbs-up.svg';
import trash from './icons/trash.svg';
import truck from './icons/truck.svg';
import twitter from './icons/twitter.svg';
import undo from './icons/undo.svg';
import unlock from './icons/unlock.svg';
import view from './icons/view.svg';
import warningSign from './icons/warning-sign.svg';
import youtube from './icons/youtube.svg';
import zoomIn from './icons/zoom-in.svg';

type SvgProps = {
	className?: string;
};

export const AccountBoxIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="AccountBoxIcon">
		<use xlinkHref={accountBox} />
	</svg>
);
export const AccountIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="AccountIcon">
		<use xlinkHref={account} />
	</svg>
);
export const AddBoxIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="AddBoxIcon">
		<use xlinkHref={addBox} />
	</svg>
);
export const AddToCartIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="AddToCartIcon">
		<use xlinkHref={addToCart} />
	</svg>
);
export const AndroidArrowDropdownIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="AndroidArrowDropdownIcon">
		<use xlinkHref={androidArrowDropdown} />
	</svg>
);
export const ApertureIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ApertureIcon">
		<use xlinkHref={aperture} />
	</svg>
);
export const AppleIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="AppleIcon">
		<use xlinkHref={apple} />
	</svg>
);
export const ArchiveIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ArchiveIcon">
		<use xlinkHref={archive} />
	</svg>
);
export const ArrowDownIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ArrowDownIcon">
		<use xlinkHref={arrowDown} />
	</svg>
);
export const ArrowLeftIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ArrowLeftIcon">
		<use xlinkHref={arrowLeft} />
	</svg>
);
export const ArrowNorthEastIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ArrowNorthEastIcon">
		<use xlinkHref={arrowNorthEast} />
	</svg>
);
export const ArrowReturnLeftIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ArrowReturnLeftIcon">
		<use xlinkHref={arrowReturnLeft} />
	</svg>
);
export const ArrowRightAIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ArrowRightAIcon">
		<use xlinkHref={arrowRightA} />
	</svg>
);
export const BriefcaseIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="BriefcaseIcon">
		<use xlinkHref={briefcase} />
	</svg>
);
export const CalendarIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CalendarIcon">
		<use xlinkHref={calendar} />
	</svg>
);
export const CallIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CallIcon">
		<use xlinkHref={call} />
	</svg>
);
export const CancelIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CancelIcon">
		<use xlinkHref={cancel} />
	</svg>
);
export const CartIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CartIcon">
		<use xlinkHref={cart} />
	</svg>
);
export const ChatBubbleIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ChatBubbleIcon">
		<use xlinkHref={chatBubble} />
	</svg>
);
export const CheckBoxIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CheckBoxIcon">
		<use xlinkHref={checkBox} />
	</svg>
);
export const CheckmarkCircledIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CheckmarkCircledIcon">
		<use xlinkHref={checkmarkCircled} />
	</svg>
);
export const CheckmarkIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CheckmarkIcon">
		<use xlinkHref={checkmark} />
	</svg>
);
export const ChevronDownIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ChevronDownIcon">
		<use xlinkHref={chevronDown} />
	</svg>
);
export const ChevronLeftIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ChevronLeftIcon">
		<use xlinkHref={chevronLeft} />
	</svg>
);
export const ChevronRightIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ChevronRightIcon">
		<use xlinkHref={chevronRight} />
	</svg>
);
export const ChevronUpIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ChevronUpIcon">
		<use xlinkHref={chevronUp} />
	</svg>
);
export const CloseCircledIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CloseCircledIcon">
		<use xlinkHref={closeCircled} />
	</svg>
);
export const CloseIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CloseIcon">
		<use xlinkHref={close} />
	</svg>
);
export const CollapseAllIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CollapseAllIcon">
		<use xlinkHref={collapseAll} />
	</svg>
);
export const ColorPaletteIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ColorPaletteIcon">
		<use xlinkHref={colorPalette} />
	</svg>
);
export const ComfortableIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ComfortableIcon">
		<use xlinkHref={comfortable} />
	</svg>
);
export const CommentIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CommentIcon">
		<use xlinkHref={comment} />
	</svg>
);
export const CompactIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CompactIcon">
		<use xlinkHref={compact} />
	</svg>
);
export const CompareArrowsIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CompareArrowsIcon">
		<use xlinkHref={compareArrows} />
	</svg>
);
export const CompareIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CompareIcon">
		<use xlinkHref={compare} />
	</svg>
);
export const ConstructIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ConstructIcon">
		<use xlinkHref={construct} />
	</svg>
);
export const ContentCopyIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ContentCopyIcon">
		<use xlinkHref={contentCopy} />
	</svg>
);
export const CopyOutlineIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CopyOutlineIcon">
		<use xlinkHref={copyOutline} />
	</svg>
);
export const CopySharpIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CopySharpIcon">
		<use xlinkHref={copySharp} />
	</svg>
);
export const CubeIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="CubeIcon">
		<use xlinkHref={cube} />
	</svg>
);
export const DeleteForeverIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="DeleteForeverIcon">
		<use xlinkHref={deleteForever} />
	</svg>
);
export const EditIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="EditIcon">
		<use xlinkHref={edit} />
	</svg>
);
export const EllipsisHorizontalIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="EllipsisHorizontalIcon">
		<use xlinkHref={ellipsisHorizontal} />
	</svg>
);
export const EmailIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="EmailIcon">
		<use xlinkHref={email} />
	</svg>
);
export const ErrorIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ErrorIcon">
		<use xlinkHref={error} />
	</svg>
);
export const ExpandAllIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ExpandAllIcon">
		<use xlinkHref={expandAll} />
	</svg>
);
export const EyeIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="EyeIcon">
		<use xlinkHref={eye} />
	</svg>
);
export const FacebookIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="FacebookIcon">
		<use xlinkHref={facebook} />
	</svg>
);
export const FergusonIsotypeIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="FergusonIsotypeIcon">
		<use xlinkHref={fergusonIsotype} />
	</svg>
);
export const FilterAltIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="FilterAltIcon">
		<use xlinkHref={filterAlt} />
	</svg>
);
export const FilterIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="FilterIcon">
		<use xlinkHref={filter} />
	</svg>
);
export const FolderIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="FolderIcon">
		<use xlinkHref={folder} />
	</svg>
);
export const GrabBarsSmallIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="GrabBarsSmallIcon">
		<use xlinkHref={grabBarsSmall} />
	</svg>
);
export const GrabBarsVerticalIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="GrabBarsVerticalIcon">
		<use xlinkHref={grabBarsVertical} />
	</svg>
);
export const GrabBarsIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="GrabBarsIcon">
		<use xlinkHref={grabBars} />
	</svg>
);
export const Grid3x3Icon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="Grid3x3Icon">
		<use xlinkHref={grid3x3} />
	</svg>
);
export const GridIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="GridIcon">
		<use xlinkHref={grid} />
	</svg>
);
export const HammerIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HammerIcon">
		<use xlinkHref={hammer} />
	</svg>
);
export const HeartIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HeartIcon">
		<use xlinkHref={heart} />
	</svg>
);
export const HelpCircleIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HelpCircleIcon">
		<use xlinkHref={helpCircle} />
	</svg>
);
export const HistoryIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HistoryIcon">
		<use xlinkHref={history} />
	</svg>
);
export const HomeOwnerIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HomeOwnerIcon">
		<use xlinkHref={homeOwner} />
	</svg>
);
export const HomeIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HomeIcon">
		<use xlinkHref={home} />
	</svg>
);
export const HouseIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HouseIcon">
		<use xlinkHref={house} />
	</svg>
);
export const HouzzIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="HouzzIcon">
		<use xlinkHref={houzz} />
	</svg>
);
export const InfoIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="InfoIcon">
		<use xlinkHref={info} />
	</svg>
);
export const InstagramIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="InstagramIcon">
		<use xlinkHref={instagram} />
	</svg>
);
export const IphoneIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="IphoneIcon">
		<use xlinkHref={iphone} />
	</svg>
);
export const LightBulbIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="LightBulbIcon">
		<use xlinkHref={lightBulb} />
	</svg>
);
export const LinkIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="LinkIcon">
		<use xlinkHref={link} />
	</svg>
);
export const ListAltIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ListAltIcon">
		<use xlinkHref={listAlt} />
	</svg>
);
export const ListIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ListIcon">
		<use xlinkHref={list} />
	</svg>
);
export const LockIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="LockIcon">
		<use xlinkHref={lock} />
	</svg>
);
export const LoopIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="LoopIcon">
		<use xlinkHref={loop} />
	</svg>
);
export const MenuIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="MenuIcon">
		<use xlinkHref={menu} />
	</svg>
);
export const MinusIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="MinusIcon">
		<use xlinkHref={minus} />
	</svg>
);
export const MoveIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="MoveIcon">
		<use xlinkHref={move} />
	</svg>
);
export const NotificationBellIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="NotificationBellIcon">
		<use xlinkHref={notificationBell} />
	</svg>
);
export const OtherIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="OtherIcon">
		<use xlinkHref={other} />
	</svg>
);
export const PaperOutlineIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PaperOutlineIcon">
		<use xlinkHref={paperOutline} />
	</svg>
);
export const PersonStalkerIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PersonStalkerIcon">
		<use xlinkHref={personStalker} />
	</svg>
);
export const PersonIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PersonIcon">
		<use xlinkHref={person} />
	</svg>
);
export const PhoneIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PhoneIcon">
		<use xlinkHref={phone} />
	</svg>
);
export const PinterestIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PinterestIcon">
		<use xlinkHref={pinterest} />
	</svg>
);
export const PlusCircledIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PlusCircledIcon">
		<use xlinkHref={plusCircled} />
	</svg>
);
export const PlusIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PlusIcon">
		<use xlinkHref={plus} />
	</svg>
);
export const PriceTagIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PriceTagIcon">
		<use xlinkHref={priceTag} />
	</svg>
);
export const PrintIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="PrintIcon">
		<use xlinkHref={print} />
	</svg>
);
export const Prop65WarningIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="Prop65WarningIcon">
		<use xlinkHref={prop65Warning} />
	</svg>
);
export const QuickShipIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="QuickShipIcon">
		<use xlinkHref={quickShip} />
	</svg>
);
export const RefreshIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="RefreshIcon">
		<use xlinkHref={refresh} />
	</svg>
);
export const ReturnsIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ReturnsIcon">
		<use xlinkHref={returns} />
	</svg>
);
export const SearchIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="SearchIcon">
		<use xlinkHref={search} />
	</svg>
);
export const SendIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="SendIcon">
		<use xlinkHref={send} />
	</svg>
);
export const ShieldCheckmarkSharpIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ShieldCheckmarkSharpIcon">
		<use xlinkHref={shieldCheckmarkSharp} />
	</svg>
);
export const ShieldCheckmarkIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ShieldCheckmarkIcon">
		<use xlinkHref={shieldCheckmark} />
	</svg>
);
export const ShipmentTrackingIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ShipmentTrackingIcon">
		<use xlinkHref={shipmentTracking} />
	</svg>
);
export const ShippingBoxIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ShippingBoxIcon">
		<use xlinkHref={shippingBox} />
	</svg>
);
export const ShoppingCartIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ShoppingCartIcon">
		<use xlinkHref={shoppingCart} />
	</svg>
);
export const SortIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="SortIcon">
		<use xlinkHref={sort} />
	</svg>
);
export const StoreFrontIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="StoreFrontIcon">
		<use xlinkHref={storeFront} />
	</svg>
);
export const ThumbsDownIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ThumbsDownIcon">
		<use xlinkHref={thumbsDown} />
	</svg>
);
export const ThumbsUpIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ThumbsUpIcon">
		<use xlinkHref={thumbsUp} />
	</svg>
);
export const TrashIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="TrashIcon">
		<use xlinkHref={trash} />
	</svg>
);
export const TruckIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="TruckIcon">
		<use xlinkHref={truck} />
	</svg>
);
export const TwitterIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="TwitterIcon">
		<use xlinkHref={twitter} />
	</svg>
);
export const UndoIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="UndoIcon">
		<use xlinkHref={undo} />
	</svg>
);
export const UnlockIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="UnlockIcon">
		<use xlinkHref={unlock} />
	</svg>
);
export const ViewIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ViewIcon">
		<use xlinkHref={view} />
	</svg>
);
export const WarningSignIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="WarningSignIcon">
		<use xlinkHref={warningSign} />
	</svg>
);
export const YoutubeIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="YoutubeIcon">
		<use xlinkHref={youtube} />
	</svg>
);
export const ZoomInIcon: FunctionComponent<SvgProps> = ({ className }) => (
	<svg className={`${defaultIcon} ${className || ''}`} data-testid="ZoomInIcon">
		<use xlinkHref={zoomIn} />
	</svg>
);
